import { render, staticRenderFns } from "./UpdateTask.vue?vue&type=template&id=c5546efc&scoped=true"
import script from "./UpdateTask.vue?vue&type=script&lang=js"
export * from "./UpdateTask.vue?vue&type=script&lang=js"
import style0 from "./UpdateTask.vue?vue&type=style&index=0&id=c5546efc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5546efc",
  null
  
)

export default component.exports